import { memo } from 'react'

import Heading from './include/Heading'
import Image from './include/Image'

function GroupPageHero({
  title,
  description,
  bannerSource,
}: GroupPageHeroProps) {
  return (
    <main className="flex flex-col w-full space-y-6 box lg:space-x-12 lg:space-y-0 lg:justify-between lg:flex-row lg:items-center">
      <Heading title={title} description={description} />
      {bannerSource && <Image src={bannerSource} />}
    </main>
  )
}

interface GroupPageHeroProps {
  title: string
  description: string
  bannerSource: string
}

export default memo(GroupPageHero)
